import httpClient from './httpClient';
import API_CONFIG from './config';

const { USERS } = API_CONFIG.ENDPOINTS;

const userApi = {
  getProfile: () => httpClient.get(USERS.PROFILE),

  updateProfile: (data) => httpClient.put(USERS.PROFILE, data),

  addRoles: (data) => httpClient.put(USERS.ROLES, data),

  getById: (id) => httpClient.get(USERS.BY_ID(id)),

  search: (params = {}) => httpClient.get(USERS.SEARCH, params),
};

export default userApi;
